import './i18n';
import './styles/responsive.css';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from "./pages/Home";
import About from "./pages/About";
import PrayerRequest from "./pages/PrayerRequest";
import Giving from "./pages/Giving";
import SupportPage from './pages/SupportPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ResponsivePage from './components/ResponsivePage';
import MobileHome from './pages/mobile/MobileHome';
import MobileAbout from './pages/mobile/MobileAbout';
import MobileGiving from './pages/mobile/MobileGiving';
import MobilePrayer from './pages/mobile/MobilePrayer';
import MobileSupport from './pages/mobile/MobileSupport';
import MobilePrivacy from './pages/mobile/MobilePrivacy';

// KAC stellt ausschließlich die bestehenden öffentlichen Seiten bereit.
function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        backgroundColor: '#f9fafb',
        fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, system-ui, sans-serif"
      }}>
        <main style={{ flex: 1, padding: '0' }}>
          <Routes>
            <Route path="/" element={<ResponsivePage desktop={Home} mobile={MobileHome} />} />
            <Route path="/about" element={<ResponsivePage desktop={About} mobile={MobileAbout} />} />
            <Route path="/opfer" element={<ResponsivePage desktop={Giving} mobile={MobileGiving} />} />
            <Route path="/gebet" element={<ResponsivePage desktop={PrayerRequest} mobile={MobilePrayer} />} />
            <Route path="/support" element={<ResponsivePage desktop={SupportPage} mobile={MobileSupport} />} />
            <Route path="/privacy" element={<ResponsivePage desktop={PrivacyPolicyPage} mobile={MobilePrivacy} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
